(function ( $ ) {
	
  
 
}( jQuery ));



